import { ColProps } from '@app/types'
import { Col as AntCol } from 'antd'

export const Col: React.FC<ColProps> = (props) => <AntCol {...props} />
